import { ENUMBER_TYPES } from "@constants";
import { IUserContactDetails, IUserDetailsInfo } from "../../interface/IUserDetails";
import { IContactAddress } from "@common/Eircode/interface/IAddressForm";

export interface IEmailResponse {
    email: string;
    type?: string;
    validated?: boolean;
}

export interface IPhoneNumberResponse {
    id: number;
    phoneNumber: string;
    type: ENUMBER_TYPES;
}

export interface IUserContactResponse {
    emails: IEmailResponse[];
    phoneNumbers: IPhoneNumberResponse[];
    firstName: string;
    lastName: string;
    addresses: IContactAddress[];
}

export const getResponseToState = (response: IUserContactResponse): IUserDetailsInfo => ({
    email: response.emails.length ? response.emails[0].email : "",
    phoneNumber: response.phoneNumbers.length ? response.phoneNumbers[0].phoneNumber : "",
    firstName: response.firstName,
    lastName: response.lastName,
    addresses: response.addresses,
});

export const getResponseToContactState = (response: IUserContactResponse): IUserContactDetails => ({
    emails: response.emails,
    phoneNumbers: response.phoneNumbers,
    firstName: response.firstName,
    lastName: response.lastName,
    addresses: response.addresses,
});
